export enum EventSubCategories {
  AUTH = `AUTH`,
  VEHICLES = `VEHICLES`,
  PAYMENT_METHODS = `PAYMENT_METHODS`,
  WALLETS = `WALLETS`,
  PARKABLE_TRANSACTIONS = `PARKABLE_TRANSACTIONS`,
  SUPPORT_TICKETS = `SUPPORT_TICKETS`,
  ACCOUNT_SETUP = `ACCOUNT_SETUP`,
}
